import axios from "axios";

const baseURL = process.env.REACT_APP_PUBLIC_URL;

const createAxiosInstance = (url) => axios.create({
  baseURL: url,
  headers: { "Content-Type": "application/json" },
});

export const axiosInstance = createAxiosInstance(baseURL);
